import { KeyTopicsType } from "./key_topics.utility.decl";

import { CallDetailsFragment } from "@/graphql/generated/graphql";

export const mapToKeyTopics = (
  transcription: CallDetailsFragment["transcription"] | null
): KeyTopicsType => {
  if (transcription?.__typename === "CallTranscription") {
    return transcription.insights?.topics?.content?.topics?.slice(0, 10);
  }
};
